import React, { useState, useEffect } from "react";
import AnnouncementBar from "./announcementBar";
import afterLoginApiAxios from "../../Util/API Calls/afterLogin";
import { withRouter } from "react-router-dom";
import Loader from "../UI Component/Loader/Loader";
import { LOCALSTORAGEKEY } from "../../Util/Helper/localStorageUtils";
import { C2CConsole } from "../../Util/Helper/C2CConsole";

function AnnouncementBarForAll(props, { showAnnouncementBarCallback }) {
  const [newFeatures, setNewFeatures] = useState([]);
  const [visibalFeature, setVisibalFeature] = useState([]);
  const [loading, setLoading] = useState(false);

  const userId = localStorage.getItem(LOCALSTORAGEKEY.USER_ID);

  const onLaterClick = (feature_id) => {
    let hidden_features = JSON.parse(sessionStorage.getItem("hidden_features"));
    if (hidden_features === null) {
      hidden_features = [];
    }
    hidden_features.push(feature_id);
    sessionStorage.setItem("hidden_features", JSON.stringify(hidden_features));
    updateVisibaleFeture();
  };
  const updateVisibaleFeture = () => {
    const hidden_features = JSON.parse(
      sessionStorage.getItem("hidden_features")
    );
    if (hidden_features !== null) {
      let temp = newFeatures.filter(
        (item) => !hidden_features.includes(item.feature_id)
      );
      setVisibalFeature(temp);
      return;
    }
    setVisibalFeature(newFeatures);
  };
  useEffect(() => {
    updateVisibaleFeture();
  }, [newFeatures]);

  useEffect(() => {
    afterLoginApiAxios
      .post("/public/get-new-features", {
        user_type: localStorage.getItem("user_type"),
        user_id: userId,
      })
      .then((res) => {
        setLoading(true);
        if (res.data.statusCode === 200 && res.data.response) {
          if (res.data.response.length > 0) {
            setNewFeatures(res.data.response);
            localStorage.setItem("feature_id", res.data.response[0].feature_id);
          }
        }
        setLoading(false);
      })
      .catch((err) => {
        C2CConsole.log(err);
        setLoading(false);
      });
  }, []);

  const onViewClick = (feature_id) => {
    afterLoginApiAxios
      .post("/public/update-feature-usage", {
        user_type: localStorage.getItem("user_type"),
        user_id: userId,
        feature_id: feature_id,
      })
      .then((res) => {
        setLoading(true);
        if (res.data.statusCode === 200) {
          localStorage.setItem("feature_id", feature_id);
          props.history.push("/doctor/account/medupdates");
          setLoading(false);
        }
      })
      .catch((err) => {
        C2CConsole.log(err);
        setLoading(false);
      });
  };

  return loading ? (
    <Loader />
  ) : (
    visibalFeature.map((feature, index) => (
      <AnnouncementBar
        key={index}
        feature={feature}
        onViewClick={onViewClick}
        onLaterClick={onLaterClick}
      />
    ))
  );
}

export default withRouter(AnnouncementBarForAll);
